export default "__VITE_ASSET__4c4a30cb__"